import * as React from "react";
import {
  Stepper,
  StepperItem,
  Breakpoint,
  Card,
  CardBody,
} from "src/components";
import styled from "styled-components";
import { useWindow } from "src/hooks";
import { MediaQueries } from "src/constants";

const ContainerEl = styled.div<{ height: number }>`
  display: table;

  ${MediaQueries.screen.medium.maxWidth} {
    height: calc(${(p) => p.height}px - 88px);
  }

  ${MediaQueries.screen.medium.minWidth} {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: auto;
    max-width: 600px;
  }
`;

export const withStepper = (activeIndex: number) => (Component: any): any => {
  return (props: any) => {
    const { innerHeight } = useWindow();

    return (
      <>
        <Breakpoint medium up>
          <ContainerEl height={innerHeight}>
            <Stepper activeIndex={activeIndex}>
              {props.stepperItems.map((item: React.ReactNode, key: number) => (
                <StepperItem key={key} text={item} />
              ))}
            </Stepper>
            <Card paddingS>
              <CardBody flex flexDirectionColumn>
                <Component {...props} />
              </CardBody>
            </Card>
          </ContainerEl>
        </Breakpoint>
        <Breakpoint medium down>
          <ContainerEl height={innerHeight}>
            <Stepper activeIndex={activeIndex}>
              {props.stepperItems.map((item: React.ReactNode, key: number) => (
                <StepperItem key={key} text={item} />
              ))}
            </Stepper>
            <Component {...props} />
          </ContainerEl>
        </Breakpoint>
      </>
    );
  };
};
